import React, { useState, useEffect, useRef } from "react";
import { Formik, Field, Form } from "formik";
import { TextField, Loading, Select } from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import {
  generate_uuid,
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useList } from "store/list";
import { handleSuccessMessages } from "store/auth";
import AddItem from "./AddItem";
import EditItem from "./EditItem";
import * as Icons from "react-feather";

import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";

// components

export default function Edit(props) {
  const path = {
    baseRoute: "/menus",
    aliasName: "منو ها",
    type: "menus",
  };

  const navigator = useNavigate();
  const { dispatch, getSingle, update, single, load } = useList();
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [item, setItem] = useState();
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const onSortEnd = ({ oldIndex, newIndex }) => {
    let temp_items = arrayMoveImmutable(items, oldIndex, newIndex);
    temp_items = temp_items.map((item, index) => ({ ...item, order: index }));
    setItems(temp_items);
  };
  useEffect(() => {
    dispatch(getSingle(path, id));
  }, []);

  useEffect(() => {
    setItems(
      single &&
        single.items &&
        single.items.map((i) => ({
          ...transformTranslateServerValues(i),
          childs: i.childs.map((ic) => ({
            ...transformTranslateServerValues(ic),
            uuid: ic.id,
          })),
          uuid: i.id,
        }))
    );
  }, [single]);

  if (load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <AddItem
        show={showAdd}
        title="افزودن آیتم"
        close={() => {
          setShowAdd(false);
        }}
        parents={items && items.map((i) => ({ label: i.title, value: i.uuid }))}
        addToList={(item) => {
          if (item.parent_id) {
            const white_list = items.filter((i) => i.uuid !== item.parent_id);
            const parent = items.filter((i) => i.uuid == item.parent_id)[0];
            parent.childs = [...parent.childs, item];
            let filnal_list = [...white_list, parent];
            setItems(filnal_list.sort((a, b) => a.order - b.order));

            return;
          }
          let filnal_list = [...items, item];
          setItems(filnal_list.sort((a, b) => a.order - b.order));
        }}
      />
      <EditItem
        show={showEdit}
        title="ویرایش آیتم"
        close={() => {
          setShowEdit(false);
        }}
        parents={items && items.map((i) => ({ label: i.title, value: i.uuid }))}
        item={item}
        editList={(item) => {
          if (item.parent_id) {
            const white_list = items.filter(
              (i) => i.uuid !== item.parent_id && i.uuid !== item.uuid
            );
            const parent = items.filter((i) => i.uuid == item.parent_id)[0];
            const t_items = parent.childs
              ? parent.childs.filter((i) => i.uuid !== item.uuid)
              : [];
            parent.childs = [...t_items, item];
            let filnal_list = [...white_list, parent];

            setItems(filnal_list.sort((a, b) => a.order - b.order));
            return;
          }
          let t_items = items.filter((i) => i.uuid !== item.uuid);
          let filnal_list = [...t_items, item];
          setItems(filnal_list.sort((a, b) => a.order - b.order));
        }}
      />
      <div className="content">
        <div className="w-full p-3 flex justify-between items-center">
          <h2>ایجاد منو</h2>
          <Link to="/settings/menus" className="btn btn-info shadow-md mr-2">
            بازگشت
          </Link>
        </div>

        <hr className="my-3" />

        <div className="w-full flex gap-x-2">
          <div className="w-1/4">
            <Formik
              initialValues={{ ...single }}
              onSubmit={async (values, { setSubmitting }) => {
                await dispatch(
                  update(
                    path,
                    id,
                    transformTranslateFromValues({
                      ...values,
                      items: items.map((item) => ({
                        ...transformTranslateFromValues(item),
                        childs: item.childs
                          ? item.childs.map((item) =>
                              transformTranslateFromValues(item)
                            )
                          : [],
                      })),
                    }),
                    () => {
                      handleSuccessMessages("عملیات با موفقیت انجام شد");
                      navigator("/settings/menus");
                    }
                  )
                );
                setSubmitting(false);
              }}
              enableReinitialize
            >
              {({ isSubmitting, dirty }) => (
                <Form>
                  <div className="box rounded py-3">
                    <div className="p-3">
                      <div className="intro-x flex-col">
                        <Field
                          placeholder="نام"
                          label="نام :"
                          name="name"
                          component={TextField}
                          validate={(value) =>
                            validationWrapper(value, required)
                          }
                        />
                        <div>
                          <Field
                            placeholder="نوع منو"
                            label="نوع منو :"
                            name="type"
                            component={Select}
                            validate={(value) =>
                              validationWrapper(value, required)
                            }
                            options={[
                              { value: "type_1", label: "نوع یک" },
                              { value: "type_2", label: "نوع دو" },
                              { value: "type_3", label: "نوع سه" },
                              { value: "type_4", label: "نوع چهار" },
                            ]}
                          />
                        </div>
                        <button
                          className="mt-4 btn btn-primary w-20"
                          type="submit"
                          disabled={!!isSubmitting}
                        >
                          {isSubmitting ? <Loading /> : "ذخیره"}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="w-3/4 box rounded p-3">
            <div className="w-full flex justify-between h-12 items-center">
              <h2 className="intro-y text-lg font-medium ">آیتم های منو</h2>
              <button
                onClick={() => {
                  setShowAdd(true);
                }}
                className="btn btn-primary btn-sm shadow-md mr-2"
              >
                افزودن آیتم
              </button>
            </div>
            <hr />
            <div className="grid grid-cols-12 gap-6 mt-5">
              <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                <table className="table table-report -mt-2">
                  <thead>
                    <tr>
                      <th className="whitespace-nowrap text-center">
                        عنوان منو
                      </th>
                      <th className="whitespace-nowrap text-center">
                        عنوان منو(en)
                      </th>

                      <th className="whitespace-nowrap text-center">لینک</th>
                      <th className="whitespace-nowrap text-center">عملیات</th>
                    </tr>
                  </thead>
                  {items && items.length > 0 && (
                    <SortableList
                      items={items}
                      onSortEnd={onSortEnd}
                      removeItem={(item) => {
                        setItems(items.filter((i) => i.uuid != item.uuid));
                      }}
                      removeChildItem={(item) => {
                        const white_list = items.filter(
                          (i) => i.uuid !== item.parent_id
                        );
                        const parent = items.filter(
                          (i) => i.uuid == item.parent_id
                        )[0];
                        parent.childs = parent.childs.filter(
                          (i) => i.uuid !== item.uuid
                        );
                        let filnal_list = [...white_list, parent];
                        setItems(filnal_list.sort((a, b) => a.order - b.order));
                      }}
                      setShowEdit={(value) => {
                        setShowEdit(value);
                      }}
                      setItem={(item) => {
                        setItem(item);
                      }}
                    />
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SortableList = SortableContainer((props) => {
  const { items } = props;

  return (
    <tbody>
      {items.map((item, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          item={item}
          removeItem={props.removeItem}
          removeChildItem={props.removeChildItem}
          setShowEdit={props.setShowEdit}
          setItem={props.setItem}
        />
      ))}
    </tbody>
  );
});
const SortableItem = SortableElement((props) => {
  const { item } = props;
  return (
    <>
      <tr className="intro-x  cursor-pointer select-none">
        <td>
          <p className="font-medium whitespace-nowrap text-center">
            {item.title}
          </p>
        </td>

        <td>
          <p className="font-medium whitespace-nowrap text-center">
            {item["_en*title*text"]}
          </p>
        </td>
        <td>
          <p className="font-medium whitespace-nowrap text-center">
            {item.link}
          </p>
        </td>

        <td className="table-report__action w-56">
          <div className="flex justify-center items-center">
            <button
              className="flex items-center ml-3 cursor-pointer"
              onClick={() => {
                props.setItem(item);
                props.setShowEdit(true);
              }}
            >
              {" "}
              <Icons.CheckSquare className="w-4 h-4 ml-1" /> ویرایش{" "}
            </button>
            <button
              href="javascript:;"
              className="flex items-center text-theme-6 cursor-pointer"
              onClick={() => {
                props.removeItem(item);
              }}
            >
              <Icons.Trash2 className="w-4 h-4 ml-1 " />
              حذف{" "}
            </button>
          </div>
        </td>
      </tr>
      {item.childs && item.childs.length > 0 && (
        <tr className="intro-x  cursor-pointer select-none">
          <td colspan="100%" style={{ backgroundColor: "#a2a2a2" }}>
            <div className="w-full grid grid-cols-12 gap-6 mt-5">
              <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                <table className="table table-report -mt-2">
                  <thead>
                    <tr>
                      <th className="whitespace-nowrap text-center">
                        عنوان منو
                      </th>
                      <th className="whitespace-nowrap text-center">
                        عنوان منو(en)
                      </th>
                      <th className="whitespace-nowrap text-center">لینک</th>
                      <th className="whitespace-nowrap text-center">عملیات</th>
                    </tr>
                  </thead>
                  {item.childs.map((item, index) => (
                    <tr
                      key={`item_${index}`}
                      className="intro-x  cursor-pointer select-none"
                    >
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.title}
                        </p>
                      </td>

                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item["_en*title*text"]}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.link}
                        </p>
                      </td>

                      <td className="table-report__action w-56">
                        <div className="flex justify-center items-center">
                          <button
                            className="flex items-center ml-3 cursor-pointer"
                            onClick={() => {
                              props.setItem(item);
                              props.setShowEdit(true);
                            }}
                          >
                            {" "}
                            <Icons.CheckSquare className="w-4 h-4 ml-1" />{" "}
                            ویرایش{" "}
                          </button>
                          <button
                            href="javascript:;"
                            className="flex items-center text-theme-6 cursor-pointer"
                            onClick={() => {
                              props.removeChildItem(item);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1 " />
                            حذف{" "}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
});
